module.exports = __webpack_public_path__ + "img/tushi.408d5398.jpg";